"use client";
import * as React from "react";

interface LockerCardProps {
  size: "Big Locker" | "Small Locker";
  number: number;
  available: number;
  used: number;
}

export function LockerCard({ size, number, available, used }: LockerCardProps) {

  return (
    <article className="card shadow-lg rounded-4 text-center h-100">
      <div className="card-body d-flex flex-column justify-content-between">
        <div className="d-flex justify-content-end align-items-start mb-3">
          <div className="d-flex align-items-center me-2">
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/f80f68d33bee678d7b0965af1d685b0c492e3c14?placeholderIfAbsent=true&apiKey=155088335b9245cc9e899591d6dc52ea"
              alt="Locker icon"
              style={{ width: "34px", height: "34px" }}
            />
          </div>
          <span className="fs-4 fw-bold text-black">{number}</span>
        </div>

        <h5 className="card-title text-uppercase fw-semibold text-muted small">{size} Locker</h5>

        <div className="d-flex justify-content-start align-items-center mt-4">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/602f2b6088024f98419b3753952b42f87de380cf?placeholderIfAbsent=true&apiKey=155088335b9245cc9e899591d6dc52ea"
            alt="Available icon"
            style={{ width: "12px", height: "12px" }}
            className="me-2"
          />
          <span className="fw-semibold text-dark me-3">{available}</span>
          {/* <span className="text-secondary">{used}</span> */}
        </div>
      </div>
    </article>
  );
}
